export const DATE_RANGE = 'date-range-wrap';
export const DATE_RANGE_MONTHS_WRAP = 'date-range-months-wrap';
export const DATE_RANGE_DAY = 'date-range-day';
